(function () {
  function replaceInNode(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      if (node.textContent.includes('Customer')) {
        node.textContent = node.textContent.replace(/\bCustomer\b/g, 'Client');
      }
    }
  }

  function scanJudgeMe() {
    document.querySelectorAll('[class*="jdgm"]').forEach(replaceInNode);
  }

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.className && typeof node.className === 'string' && node.className.includes('jdgm')) {
          replaceInNode(node);
        } else {
          node.querySelectorAll('[class*="jdgm"]').forEach(replaceInNode);
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scanJudgeMe);
  } else {
    scanJudgeMe();
  }
})();